/**
 * Coordinates - Represents a geographic location
 *
 * Maps to backend: MentionedMe.Domain.ValueObjects.Coordinates
 */
export interface Coordinates {
  latitude: number;
  longitude: number;
}

/**
 * Validate coordinates are within valid ranges
 */
export function isValidCoordinates(coords: Coordinates): boolean {
  return (
    coords.latitude >= -90 &&
    coords.latitude <= 90 &&
    coords.longitude >= -180 &&
    coords.longitude <= 180
  );
}

/**
 * Create Coordinates from latitude and longitude
 */
export function createCoordinates(latitude: number, longitude: number): Coordinates {
  const coords: Coordinates = { latitude, longitude };

  if (!isValidCoordinates(coords)) {
    throw new Error(
      `Invalid coordinates: latitude must be between -90 and 90, longitude must be between -180 and 180. Got: ${latitude}, ${longitude}`
    );
  }

  return coords;
}

/**
 * Format coordinates as a display string
 */
export function formatCoordinates(coords: Coordinates): string {
  return `${coords.latitude.toFixed(6)}, ${coords.longitude.toFixed(6)}`;
}
